import useQuestions from './useQuestions';
import { ReadOnlyBanner } from 'components/ReadOnlyGuard';
import { useState } from 'react';
import SearchableSelect from 'components/SearchableSelect';
import PropertyCombobox from 'components/PropertyCombobox';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal';
import QuestionFormModal from './QuestionFormModal';
import ActivarPreguntaModal from './ActivarPreguntaModal';
import TemporizadorVotacion, { fijarTemporizador } from 'components/TemporizadorVotacion';
import EstadoAsambleaAviso, { MOTIVO_NO_INICIADA, MOTIVO_FINALIZADA, CLASE_BLOQUEADO } from './EstadoAsambleaAviso';
import { decisionDe } from './decisiones';
import CuorumPanel from 'components/CuorumPanel';
import styles from './Questions.module.css';

function QuestionTable({ questions, onToggle, onEdit, onDelete, isReadOnly, status }) {
  // R108: abrir/cerrar solo con la asamblea en progreso; editar/borrar no con la asamblea finalizada.
  const motivoToggle = status === 'pendiente' ? MOTIVO_NO_INICIADA : status === 'finalizada' ? MOTIVO_FINALIZADA : '';
  const motivoEdicion = status === 'finalizada' ? MOTIVO_FINALIZADA : '';
  return (
    <div className="table-wrapper">
      <table>
        <thead>
          <tr><th>#</th><th>Pregunta</th><th>Tipo</th><th>Estado</th>{!isReadOnly && <th>Acciones</th>}</tr>
        </thead>
        <tbody>
          {questions.map(q => (
            <tr key={q.id} className={styles.fila}>
              <td className={styles.celdaId}>#{q.id}</td>
              <td><strong>{q.question_text || '—'}</strong></td>
              <td>
                <span className="badge badge-secondary">{q.question_type || '—'}</span>
                {q.question_type === 'yes_no' && decisionDe(q.tipo_decision) && (
                  <div className={styles.notaDecision}>
                    {decisionDe(q.tipo_decision).icono} {decisionDe(q.tipo_decision).titulo}
                  </div>
                )}
              </td>
              <td>
                <span className={`badge ${q.active ? 'badge-success' : 'badge-secondary'}`}>
                  {q.active ? <><i className={`fas fa-circle ${styles.puntoEstado}`} />Abierta</> : 'Cerrada'}
                </span>
                {q.active && <div className={styles.temporizador}><TemporizadorVotacion preguntaId={q.id} conAcciones /></div>}
              </td>
              {!isReadOnly && <td><div className="actions">
                <button className={`btn btn-sm ${q.active ? 'btn-warning' : 'btn-success'} ${motivoToggle ? CLASE_BLOQUEADO : ''}`} onClick={() => onToggle(q)}
                  disabled={!!motivoToggle} title={motivoToggle}>
                  <i className={`fas ${q.active ? 'fa-pause' : 'fa-play'}`} /> {q.active ? 'Cerrar votación' : 'Abrir votación'}
                </button>
                <button className={`btn btn-sm btn-secondary btn-icon ${motivoEdicion ? CLASE_BLOQUEADO : ''}`} onClick={() => onEdit(q)} disabled={!!motivoEdicion} title={motivoEdicion}><i className="fas fa-pencil" /></button>
                <button className={`btn btn-sm btn-danger btn-icon ${motivoEdicion ? CLASE_BLOQUEADO : ''}`} onClick={() => onDelete(q)} disabled={!!motivoEdicion} title={motivoEdicion}><i className="fas fa-trash" /></button>
              </div></td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function AssemblyGroup({ asm, onToggle, onEdit, onDelete, isReadOnly, status }) {
  const [open, setOpen] = useState(true);
  const activeCount = asm.questions.filter(q => q.active).length;
  return (
    <div className={styles.grupo}>
      <div onClick={() => setOpen(o => !o)}
        className={styles.grupoCabecera}>
        <div className={styles.grupoTitulo}>
          <i className={`fas fa-chevron-${open ? 'down' : 'right'} ${styles.chevron}`} />
          <span className={styles.grupoNombre}>{asm.label}</span>
          <span className={styles.grupoCuenta}>· {asm.questions.length} pregunta{asm.questions.length !== 1 ? 's' : ''}</span>
        </div>
        <div className={styles.grupoInsignias}>
          {activeCount > 0 && (
            <span className="badge badge-success">
              <i className={`fas fa-circle ${styles.puntoEstado}`} />{activeCount} abierta{activeCount !== 1 ? 's' : ''}
            </span>
          )}
          <span className="badge badge-secondary">{asm.questions.length}</span>
        </div>
      </div>
      {open && <QuestionTable questions={asm.questions} onToggle={onToggle} onEdit={onEdit} onDelete={onDelete} isReadOnly={isReadOnly} status={status} />}
    </div>
  );
}

export default function Questions() {
  const {
    items, loading, show, form, faltaDecision, errorForm, activar, setActivar, abriendo, setAbriendo,
    alert, setAlert, editing, confirmDel, setConfirmDel, deleting, properties, assemblies,
    loadingAssemblies, filterProp, filterAsm, isSuperAdmin, isAssemblyAdmin, user, isReadOnly,
    selectedPropBlocked, handleFilterProp, handleFilterAsm, save, toggle, cambiarEstado, del,
    confirmDelete, openEdit, openNew, close, set, groupedAsm, selectedPropName, selectedAsm,
    selectedAsmLabel, needsPropSelect, waitingProp, waitingAsm, canCreate,
  } = useQuestions();

  return (
    <div>
      <div className="page-header">
        <div>
          <h1><i className={`fas fa-circle-question ${styles.iconoCabecera}`} />Preguntas de Votación</h1>
          <p>
            {isSuperAdmin
              ? filterAsm
                ? `${selectedAsmLabel} · ${selectedPropName}`
                : filterProp
                  ? `${selectedPropName} — selecciona una asamblea`
                  : 'Selecciona una propiedad y asamblea'
              : filterAsm
                ? `${selectedAsmLabel}`
                : 'Selecciona una asamblea para ver sus preguntas'}
          </p>
        </div>

        <div className={styles.acciones}>

          {/* Filtro propiedad — super_admin y admin multi-propiedad */}
          {(isSuperAdmin || (!isAssemblyAdmin && user?.role === 'admin' && properties.length > 1)) && !isAssemblyAdmin && (
            <div className={styles.filtro}>
              <i className={`fas fa-building ${styles.iconoFiltro}`} />
              <PropertyCombobox value={filterProp} onChange={handleFilterProp} placeholder="— Selecciona propiedad —" />
              {filterProp && (
                <button className="btn btn-sm btn-secondary btn-icon" onClick={() => handleFilterProp('')} title="Limpiar">
                  <i className="fas fa-times" />
                </button>
              )}
            </div>
          )}

          {/* Filtro asamblea — solo para admin/super_admin; assembly_admin carga automáticamente */}
          {!isAssemblyAdmin && (!isSuperAdmin || filterProp) && !needsPropSelect && (
            <div className={styles.filtro}>
              <i className={`fas fa-gavel ${styles.iconoFiltro}`} />
              {loadingAssemblies ? (
                <div className={styles.cargandoAsambleas}>
                  <div className={`spinner ${styles.spinnerCarga}`} /> Cargando...
                </div>
              ) : (
                <>
                  <SearchableSelect value={filterAsm} onChange={(id) => handleFilterAsm(id)} placeholder="— Selecciona asamblea —" minWidth={200} maxWidth={280} ariaLabel="Asamblea"
                    options={assemblies.map(a => ({ value: a.id, label: `#${a.number_assembly}${a.assembly_type ? ` · ${a.assembly_type}` : ''}${a.status ? ` [${a.status}]` : ''}` }))} />
                  {filterAsm && (
                    <button className="btn btn-sm btn-secondary btn-icon" onClick={() => handleFilterAsm('')} title="Limpiar">
                      <i className="fas fa-times" />
                    </button>
                  )}
                </>
              )}
            </div>
          )}

          {(!isReadOnly || selectedAsm?.status === 'en_progreso') && (
            <button
              className={`btn btn-primary ${(!canCreate || selectedAsm?.status === 'finalizada') ? CLASE_BLOQUEADO : ''}`}
              onClick={openNew}
              disabled={!canCreate || selectedAsm?.status === 'finalizada'}
              title={!canCreate ? 'Selecciona una asamblea primero' : selectedAsm?.status === 'finalizada' ? MOTIVO_FINALIZADA : ''}
            >
              <i className="fas fa-plus" /> Nueva pregunta
            </button>
          )}
        </div>
      </div>

      <ReadOnlyBanner />
      {!loadingAssemblies && selectedAsm && <EstadoAsambleaAviso status={selectedAsm.status} />}
      {/* F-17 (a): avisos de cuórum (no verificado / perdido). Solo informan. */}
      {!loadingAssemblies && selectedAsm && <CuorumPanel assembly={selectedAsm} compacto />}
      {selectedPropBlocked && (
        <div className={styles.bannerBloqueo}>
          <i className={`fas fa-ban ${styles.iconoBloqueo}`} />
          <span>
            <strong>Acceso bloqueado.</strong> La membresía de esta propiedad ha vencido
            y el período de gracia ha expirado. No se pueden gestionar preguntas hasta renovar.
          </span>
        </div>
      )}
      {alert && (
        <div className={`alert alert-${alert.type} ${styles.aviso}`} onClick={() => setAlert(null)}>
          {alert.message}
        </div>
      )}

      {/* Estado: espera selección de propiedad */}
      {waitingProp && (
        <div className="card">
          <div className="empty-state">
            <i className={`fas fa-building ${styles.vacioIcono}`} />
            <p className={styles.vacioTexto}>Selecciona una propiedad para comenzar</p>
          </div>
        </div>
      )}

      {/* Estado: espera selección de asamblea */}
      {!waitingProp && waitingAsm && !loadingAssemblies && (
        <div className="card">
          <div className="empty-state">
            <i className={`fas fa-gavel ${styles.vacioIcono}`} />
            <p className={styles.vacioTexto}>
              {assemblies.length === 0
                ? `No hay asambleas registradas${selectedPropName ? ` en "${selectedPropName}"` : ''}`
                : 'Selecciona una asamblea para ver sus preguntas'}
            </p>
          </div>
        </div>
      )}

      {/* Cargando asambleas */}
      {loadingAssemblies && <div className="loading"><div className="spinner" /></div>}

      {/* Cargando preguntas */}
      {!loadingAssemblies && loading && <div className="loading"><div className="spinner" /></div>}

      {/* Sin preguntas en la asamblea */}
      {!loading && !loadingAssemblies && filterAsm && items.length === 0 && (
        <div className={`card ${styles.tarjetaVacia}`}>
          <i className={`fas fa-circle-question ${styles.iconoVacioGrande}`} />
          <p className={styles.vacioTexto}>No hay preguntas en {selectedAsmLabel || 'esta asamblea'}</p>
          <button className={`btn btn-primary ${styles.botonPrimera} ${selectedAsm?.status === 'finalizada' ? CLASE_BLOQUEADO : ''}`} onClick={openNew}
            disabled={selectedAsm?.status === 'finalizada'} title={selectedAsm?.status === 'finalizada' ? MOTIVO_FINALIZADA : ''}>
            <i className="fas fa-plus" /> Crear primera pregunta
          </button>
        </div>
      )}

      {/* Lista de preguntas agrupadas por asamblea */}
      {!loading && !loadingAssemblies && filterAsm && items.length > 0 && (
        <div>
          {groupedAsm.map(asm => (
            <AssemblyGroup key={asm.id} asm={asm} onToggle={toggle} onEdit={openEdit} onDelete={del} isReadOnly={isReadOnly && asm.status !== 'en_progreso'} status={assemblies.find(a => String(a.id) === String(asm.id))?.status} />
          ))}
        </div>
      )}

      {/* Modal crear/editar */}
      {show && (
        <QuestionFormModal editing={editing} form={form} set={set} assemblies={assemblies} save={save} close={close} faltaDecision={faltaDecision} error={errorForm} />
      )}
      {activar && (
        <ActivarPreguntaModal pregunta={activar} abriendo={abriendo}
          onClose={() => setActivar(null)}
          onCambiar={() => { const q = activar; setActivar(null); openEdit(q); }}
          onAbrir={async (min) => { setAbriendo(true); const ok = await cambiarEstado(activar); if (ok) fijarTemporizador(activar.id, min); setAbriendo(false); setActivar(null); }} />
      )}

      {confirmDel && (
        <ConfirmDeleteModal title="Eliminar pregunta" onClose={() => setConfirmDel(null)} onConfirm={confirmDelete} deleting={deleting}>
          <div className={styles.confirmaTitulo}>
            ¿Eliminar <span className={styles.confirmaNombre}>{confirmDel.question_text || 'esta pregunta'}</span>?
          </div>
        </ConfirmDeleteModal>
      )}
    </div>
  );
}